<template>
    <pop
        :showMask="true"
        :allowClose="true"
        :outClose="false"
        class="register-questions-pop"
        :class="{ 'show-schedule-tour': showScheduleTourAdsStep, 'show-phone-popup-step': showPhonePopupStep, 'show-finish-page': showLastStep }"
        ref="questionsRef"
        :onClose="adRegisterClose"
    >
        <div class="questions-container" :style="injectRootVar">
            <div class="questions-bg">
                <div class="loading-lang" v-if="loadingLang">
                    <div class="loading-lang-icon"></div>
                </div>
                <template v-else>
                    <!-- <Describe v-if="firstStep" @change="changeDescribe"></Describe> -->
                    <FinishPage
                        v-if="showLastStep"
                        @handleClick="handleSaveClick"
                    />
                    <HomePage v-else-if="showHomePageStep" @handleNextStep="handleHomePageClick" />
                    <ScheduleTourAds v-else-if="showScheduleTourAdsStep" @handleNextStep="handleScheduleTourAdsClick" />
                    <PhonePopup :phoneNumber="phoneNumber" v-else-if="showPhonePopupStep" @nextStep="handlePhonePopupClick" @handleSkip="handlePhonePopupClick" />
                    <Questions
                        v-show="!(showLastStep || showHomePageStep || showScheduleTourAdsStep || showPhonePopupStep)"
                        :isBuyerRole="isBuyerRole"
                        :questionConfigs="questionConfigs"
                        :finishedBehavior="finishedBehavior"
                        :currentStep="step"
                        :resultList="resultList"
                        :hasPhoneAddOn="hasPhoneAddOn"
                        :hasValidPhone="hasValidPhone"
                        @updateResultList="updateResultList"
                        @finishedQuestions="finishedQuestions"
                        @showHomePage="showHomePage"
                        @showScheduleTourAds="showScheduleTourAds"
                        @showPhonePopup="showPhonePopup"
                        @resetHomeAndSchedule="resetHomeAndSchedule"
                    />
                </template>
            </div>
        </div>
    </pop>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { useUserStore } from '@/store';
// import Describe from './describe.vue';
import FinishPage from './finishPage.vue';
import Questions from './newQuestions';
import HomePage from './homePage.vue';
import ScheduleTourAds from './scheduleTourAds.vue';
import PhonePopup from '../registerPhoneValidPop/components/phoneValid.vue';
import {
    ROLE_MAP,
    // getSellerRequestionList,
    getBuyerRequestionListNew,
} from './const.js';
import { calcColorRootVar } from '@/init/data/handlerData.js';
export default {
    props: {
        describeToQuestion: {
            type: Boolean,
            default: false
        }
    },
    i18next: {
        ns: 'common'
    },
    data: function() {
        return {
            step: 1, // 当前显示的是第几步的问题
            houseType: '',
            buyerRequestionList: [],
            sellerRequestionList: [],
            finishedBehavior: [],
            // unAnswerIndex: -1,
            oldLeadType: null,
            showLastStep: false, // means show finish page
            showHomePageStep: false, // means show home page
            hasValidPhone: false,
            showPhonePopupStep: false, // means show phone popup page
            showScheduleTourAdsStep: false, // means show schedule tour ads page
            hasPhoneAddOn: false,
            homeAddress: '',
            scheduleTourParams: null,
            resultList: [], // 存放问卷的选择结果， 在提交的时候调接口
            loadingLang: true,
        };
    },
    components: {
        // Describe,
        FinishPage,
        Questions,
        HomePage,
        ScheduleTourAds,
        PhonePopup
    },
    computed: {
        ...rootMapState(useUserStore, {
            user: store => store.user
        }),
        phoneNumber() {
            return this.user?.phoneNumber || '';
        },
        leadTypes() {
            return this.user?.leadTypes || [];
        },
        isMobile() {
            return this.platform.isMobile;
        },
        isBuyerRole() {
            if (this.oldLeadType) {
                return this.oldLeadType === 'Buyer';
            }
            return this.leadTypes?.includes(ROLE_MAP.Buyer);
        },
        isOwnerHouse() {
            return this.houseType == 'owner';
        },
        isBuyerHouse() {
            return this.houseType == 'buyer';
        },
        questionConfigs() {
            return this.isBuyerRole
                ? this.buyerRequestionList
                : this.sellerRequestionList;
        },
        injectRootVar() {
            return calcColorRootVar.call(this, {
                colors: [
                    '--g-btn-background_10',
                    '--g-primary-color_90',
                    '--g-tip-color_60'
                ]
            });
        }
    },
    created() {
        this.loadingLang = true;
        this.getHasPhoneAddOn();
        this.onLngNsLoaded('common').then(() => {
            this.loadingLang = false;
            this.getFinishQuestions();
        });
    },
    methods: {
        getHasPhoneAddOn() {
            window.siteAxios
                .get('/api-site/register/phone-addon?_t=' + Date.now())
                .then(res => {
                    this.hasPhoneAddOn = !!res?.data;
                });
        },
        init() {
            localStorage.setItem('__ad_questions', '1');
            const list = getBuyerRequestionListNew({
                $t: this.$t,
                hasValidPhone: this.hasValidPhone
            }).filter(item => item.show);
            // this.unAnswerIndex = 0;
            this.buyerRequestionList = list;
            this.step = 1;
        },
        getFinishQuestions() {
            this.axiosIns
                .get(
                    '/api-site/questionnaire/leadBehaviorAction?_t=' +
                        Date.now()
                )
                .then(res => {
                    const list = res?.data || [];
                    this.finishedBehavior = list.filter(
                        item => item.behavior != 'alreadyValidPhone'
                    );
                    this.hasValidPhone = list.findIndex(
                        item => item.behavior == 'alreadyValidPhone'
                    ) >= 0;
                    this.init();
                });
        },
        // changeDescribe(item = {}) {
        //     this.houseType = item.key;
        //     const note =
        //         this.houseType === 'owner'
        //             ? 'Lead has added additional personal info: Lead is a homeowner'
        //             : 'Lead has added additional personal info: Lead is a renter';
        //     const params = {
        //         behavior: 'questionDescribeMyself',
        //         extraData: this.houseType,
        //         note
        //     };
        //     this.addNote(params);
        //     this.changeLeadType(item.type).then(_ => {
        //         this.step = 2;
        //     });
        // },
        // addNote(params = {}) {
        //     return this.axiosIns.post('/api-site/questionnaire/addNote', {
        //         ...params
        //     });
        // },
        // changeLeadType(leadTypeList) {
        //     return this.axiosIns.post('/api-site/questionnaire/sync/leadType', {
        //         leadTypeList
        //     });
        // },
        async handleSaveClick() { // 最终提交
            const step2Info = this.resultList.find(item => item.behavior === 'questionPreQualified') || {};
            const step4Info = this.resultList.find(item => item.behavior === 'questionSellingBuyNew') || {};
            const step5Info = this.resultList.find(item => item.behavior === 'questionWantBuyingTime') || {};
            if (this.homeAddress) {
                await this.saveHomePageInfo();
                if (step4Info.extraData) {
                    step4Info.extraData.homeAddress = this.homeAddress;
                }
            }
            if (this.scheduleTourParams) {
                await this.saveScheduleTourInfo();
            } 
            const leadType = step4Info.extraData?.isHomeowner ? 'Homeowner' : '';
            const leadFields = {
                preQualified: step2Info.extraData?.preQualified || '',
                timeFrame: step5Info.extraData?.timeFrame || ''
            }
            const params = {
                leadFields,
                addLeadTypes: leadType ? [leadType] : [],
                steps: this.resultList.map(item => {
                    return {
                        ...item,
                        extraData: JSON.stringify(item.extraData || {})
                    }
                }),
            }
            const res = await this.axiosIns.post('/api-site/questionnaire/ppc/submit', {
                ...params
            });
            console.log('save questionnaire result ===>>>', res);

            this.$refs?.questionsRef?.hide?.();
            this.$refs?.questionsRef?.destroy?.(true);
            localStorage.setItem('__register__ad_questions', Date.now());
        },
        async saveHomePageInfo() {
            await this.axiosIns.get('/api-site/evaluation/report-json', {
                params: {
                    address: this.homeAddress.trim(),
                    unit: '',
                    useEvaluation: 1,
                    isTimeLine: 0
                }
            });
        },
        async saveScheduleTourInfo() {
            await this.axiosIns.post('/api-site/record/visitorInfo', {
                ...(this.scheduleTourParams || {})
            });
        },
        showHomePage() {
            this.showHomePageStep = true;
        },
        showPhonePopup() {
            this.showPhonePopupStep = true;
        },
        handlePhonePopupClick() {
            this.showPhonePopupStep = false;
            this.showLastStep = true;
        },
        handleHomePageClick(data = {}) {
            this.homeAddress = data?.homeAddress || '';
            this.showHomePageStep = false;
            this.step = 4; // means show question4
        },
        showScheduleTourAds() {
            this.showScheduleTourAdsStep = true;
        },
        handleScheduleTourAdsClick(data = {}) {
            this.scheduleTourParams = data?.scheduleTourParams || null;
            this.showScheduleTourAdsStep = false;
            this.showLastStep = true;
        },
        finishedQuestions({ isFinished, goFinishedPage } = {}) {
            if (isFinished && goFinishedPage) {
                this.showLastStep = true;
            } else {
                this.close();
            }
        },
        // changeHouseType(type) {
        //     this.houseType = type;
        //     this.sellerRequestionList = getSellerRequestionList(
        //         this.isBuyerHouse
        //     );
        // },
        adRegisterClose() {
            this.close();
        },
        close() {
            this.handleSaveClick();
        },
        updateResultList(list) {
            this.resultList = list;
        },
        resetHomeAndSchedule() {
            this.homeAddress = '';
            this.scheduleTourParams = null;
        }
    }
};
</script>

<style lang="scss" scope>
@import '@/theme/mixin.scss';
.register-questions-pop {
    .pop {
        .icon-close {
            z-index: 100;
            display: block;
            top: 15px;
            &::before {
                color: #A8A8A8;
            }
        }
        @include media-600 {
            width: calc(100% - 30px);
        }
    }
    .pop-out-close {
        display: none;
    }
    &.show-schedule-tour {
        .questions-container { 
            min-height: 755px;
            .questions-bg {
                height: 100%;
            }
        }
    }
    &.show-phone-popup-step {
        .questions-container {
            min-height: 610px;
            .questions-bg {
                height: 100%;
            }
        }
    }
    &.show-finish-page {
        .questions-container {
            min-height: 300px;
            .questions-bg {
                height: 100%;
            }
        }
    }
}

.register-questions-pop .questions-container {
    position: relative;
    width: 400px;
    min-height: 560px;
    margin: 0 auto;
    @include media-600 {
        width: 100%;
    }
    .questions-bg {
        position: absolute;
        z-index: 3;
        width: 100%;
        height: 530px;
        padding: 30px;
        box-sizing: border-box;
    }
    .questions-bg2 {
        position: absolute;
        z-index: 2;
        width: calc(100% - 40px);
        height: 525px;
        margin: 20px 20px 0;
    }
    .questions-bg3 {
        position: absolute;
        z-index: 1;
        width: calc(100% - 80px);
        height: 520px;
        margin: 40px 40px 0;
    }
    .questions-bg,
    .questions-bg2,
    .questions-bg3 {
        top: 0;
        left: 0;
        right: 0;
        border-radius: 0;
        background: rgba(255, 255, 255, 1);
        // box-shadow: 0px 5px 65px 0px rgba(0, 0, 0, 0.1) inset,
        //     0px 5px 15px 0px rgba(0, 0, 0, 0.1) inset,
        //     0px 5px 15px 0px rgba(0, 0, 0, 0.1) inset,
        //     0px 5px 15px 0px rgba(0, 0, 0, 0.03);
    }
    .register-finish-page {
        justify-content: center;
        .finish-page-content {
            flex: none;
        }
        .finish-page-button {
            margin-bottom: 0px;
        }
    }
    .loading-lang {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        min-height: 400px;
    }
    .loading-lang-icon {
        width: 40px;
        height: 40px;
        border: 3px solid #f3f3f3;
        border-top: 3px solid #3498db;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
    
}
</style>
<style lang="scss">
.register-questions-pop { 
    .questions-container {
        .register-phone-valid-container {
            .title {
                margin-top: 10px;
            }
        }
    }
}
</style>
